import { render, staticRenderFns } from "./reminderInfo.vue?vue&type=template&id=100355d2&scoped=true&"
import script from "./reminderInfo.vue?vue&type=script&lang=js&"
export * from "./reminderInfo.vue?vue&type=script&lang=js&"
import style0 from "./reminderInfo.vue?vue&type=style&index=0&id=100355d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100355d2",
  null
  
)

export default component.exports